// extracted by mini-css-extract-plugin
export default {"main":"_6e77a96571 _2977baa476","xmark":"_13f4e932a4","fl_img":"_8e5e938174 _46ac41d22d"};